<template>
  <div
    class="flex flex-col"
    :class="
      variant === 'modal'
        ? 'mt-3.5'
        : 'min-h-0 flex-1 pb-[calc(51px+env(safe-area-inset-bottom))]'
    "
  >
    <div
      class="flex flex-col"
      :class="[
        variant === 'modal' ? 'h-[530px]' : 'min-h-0 flex-1',
        variant === 'modal' && checker.mode.value !== 'visual' && 'px-6',
      ]"
    >
      <CheckerAudio
        v-show="checker.mode.value === 'audio'"
        :variant="variant"
      />
      <CheckerVisual
        v-if="checker.mode.value === 'visual'"
        :variant="variant"
      />
      <CheckerUpload
        v-else-if="checker.mode.value === 'upload'"
        :variant="variant"
      />
    </div>

    <div class="relative z-10 flex flex-col items-center">
      <p
        class="mx-auto text-center"
        :class="[
          variant === 'modal'
            ? 'mt-3.5 text-[14px] leading-5'
            : 'text-[16px] leading-[22px]',
          checker.error.value ? 'text-red-500' : 'text-gray-800',
        ]"
        :style="{ maxWidth: `${helperWidth}px` }"
      >
        {{ checker.error.value ?? HELPER[checker.mode.value] }}
      </p>
      <CheckerModeTabs
        v-if="variant === 'modal'"
        class="mt-[30px]"
        :mode="checker.mode.value"
        @change="checker.setMode"
      />
      <CheckerModeBar
        v-else
        class="mt-[30px]"
        :mode="checker.mode.value"
        :disabled="checker.busy.value"
        @change="checker.setMode"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import CheckerAudio from './CheckerAudio.vue'
import CheckerModeBar from './CheckerModeBar.vue'
import CheckerModeTabs from './CheckerModeTabs.vue'
import CheckerUpload from './CheckerUpload.vue'
import CheckerVisual from './CheckerVisual.vue'
import { useChecker, type CheckerMode } from './useChecker'

const props = defineProps<{ variant: 'modal' | 'sheet' }>()

const HELPER: Record<CheckerMode, string> = {
  audio: 'Play the audio nearby to compare to your Dacr registrations',
  visual: 'Point the camera at something to compare to your Dacr registrations',
  upload: 'Upload a file to compare to your Dacr registrations',
}

const WIDTHS: Record<'modal' | 'sheet', Record<CheckerMode, number>> = {
  modal: { audio: 250, visual: 278, upload: 218 },
  sheet: { audio: 250, visual: 286, upload: 260 },
}

const checker = useChecker()

const helperWidth = computed(() =>
  checker.error.value ? 320 : WIDTHS[props.variant][checker.mode.value]
)
</script>
